import { put, takeLatest, call } from 'redux-saga/effects';
import { SET_LOGIN_STATUS, LOG_IN, LOG_OUT } from '../redux/action/types';
import { LS_ACCESS_TOKEN, LS_REFRESH_TOKEN } from '../constants';
import { authApi } from '../utils/api';

function* logOut(action) {
  try {
    // try to call auth server
    if (!action.data.force) {
      yield call(authApi.logout);
    }
  } catch (err) {
    console.log('logOut error', err);
  } finally {
    yield put({
      type: SET_LOGIN_STATUS,
      payload: false,
    });
    if (action && action.data && action.data.onSuccess) {
      action.data.onSuccess();
    }

    localStorage.removeItem(LS_ACCESS_TOKEN);
    localStorage.removeItem(LS_REFRESH_TOKEN);
    window.location.reload();
  }
}

function* logIn() {
  const token = yield localStorage.getItem(LS_ACCESS_TOKEN);
  if (token) {
    yield put({
      type: SET_LOGIN_STATUS,
      payload: true,
    });
  }
}

function* appSaga() {
  yield takeLatest(LOG_OUT, logOut);
  yield takeLatest(LOG_IN, logIn);
}

export default appSaga;
